
let cachedData = null;

const getServiceDataWithDBHeaders = (url, headers) => {
    console.log('url', url)
    return fetch(url, {
        headers : {
            'Authorization': 'Basic dml6Zm06RHJpbGxEb3duUHdk'
        }
    })
    .then(response => {
        cachedData = response.json();
        return cachedData;
    });

};

const putServiceDataWithDBHeaders = (url, body) => {
    console.log('url', url, body)
    return fetch(url, {
        method: 'PUT',
        headers : {
            'Authorization': 'Basic dml6Zm06RHJpbGxEb3duUHdk',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    })
    .then(response => {
        cachedData = response.json();
        return cachedData;
    });

};

// const getServiceDataWithHeaders = (url, headers) => {
//     //console.log('url', url);
//     let newUrl = 'https://api.vizfm.com/v1/ext/test'
//     //url = url.replace('https://financialmodelingprep.com/','https://apiredirect.vizfm.com/');
//     url = url.replace('https://financialmodelingprep.com/','');
//     console.log('url', newUrl, url);
//     return fetch(newUrl, {
//         headers : {
//             'Authorization': 'Basic dml6Zm06RHJpbGxEb3duUHdk',
//             'api': url
//         }
//     })
//     .then(response => { 
//         cachedData = response.json();
//         return cachedData;
//     });
// };

const getServiceDataWithHeaders = (url, headers) => {
    console.log('url', url)
    return fetch(url, {
        headers : {}
    })
    .then(response => {
        cachedData = response.json();
        return cachedData;
    });
};

const convertDate = (date) => {
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth()+1).toString();
    var dd  = date.getDate().toString();
  
    var mmChars = mm.split('');
    var ddChars = dd.split('');
  
    return yyyy + '-' + (mmChars[1]?mm:"0"+mmChars[0]) + '-' + (ddChars[1]?dd:"0"+ddChars[0]);
};

const convertToInternationalCurrencySystem = (num) => {
    
    var units = ["M","B","T","Q"]
    var unit = Math.floor((num / 1.0e+1).toFixed(0).toString().length)
    var r = unit%3
    var x =  Math.abs(Number(num))/Number('1.0e+'+(unit-r)).toFixed(2)
    return x.toFixed(2)+ ' ' + units[Math.floor(unit / 3) - 2]
}; 

const convertDateForIos = (date) => {
    var arr = date.split(/[- :]/);
    date = new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]);
    return date;
}	

export {getServiceDataWithHeaders, convertDate, convertToInternationalCurrencySystem, convertDateForIos, getServiceDataWithDBHeaders, 
    putServiceDataWithDBHeaders};